/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-central-1",
    "aws_cognito_identity_pool_id": "eu-central-1:56c2544c-0d1f-4be4-be1c-43fb2a7d2384",
    "aws_cognito_region": "eu-central-1",
    "aws_user_pools_id": "eu-central-1_1F5uBbG3K",
    "aws_user_pools_web_client_id": "4c8tdplpp2p47qp6g0pfpn09ht",
    "oauth": {
        "domain": "amplifycongitoauth-go-products.auth.eu-central-1.amazoncognito.com"
    },
    "aws_cognito_username_attributes": [],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [],
    "aws_cognito_mfa_configuration": "OFF",
    "aws_cognito_mfa_types": [],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": [
            "REQUIRES_LOWERCASE",
            "REQUIRES_UPPERCASE",
            "REQUIRES_NUMBERS",
            "REQUIRES_SYMBOLS"
        ]
    },
    "aws_cognito_verification_mechanisms": [],
    "aws_appsync_graphqlEndpoint": "https://6rmgboggebfkblcahrsuuy7xyq.appsync-api.eu-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "eu-central-1",
    "aws_appsync_authenticationType": "AWS_LAMBDA",
    "aws_cloud_logic_custom": [
        {
            "name": "GetProductsRestAPI",
            "endpoint": "https://z4pmn42aij.execute-api.eu-central-1.amazonaws.com/master",
            "region": "eu-central-1"
        }
    ],
    "aws_content_delivery_bucket": "awsdrtool-hostingbucket-146798337852-eu-central-1-master",
    "aws_content_delivery_bucket_region": "eu-central-1",
    "aws_content_delivery_url": "https://d189yy21sv61z6.cloudfront.net"
};


export default awsmobile;
